import React from 'react';

const SessionContext = React.createContext(null);

export default SessionContext;
